import type { Ref } from 'vue';
import { computed } from 'vue';

import type { ITranslationsKeyMap } from '@modules/i18n/types';
import { useConfig } from '@modules/config/composables';

import { getProductsLocaleObject } from '../utils';

export function getTranslationKeys(): Ref<ITranslationsKeyMap> {
  const { config } = useConfig();

  return computed(() => ({
    admin: {
      partnership_program: {
        admin_fees: {
          header: 'ADMIN_FEES_HEADER',
          form: {
            date: 'FORM_DATE',
            general_config: {
              subheader: 'FORM_GENERAL_CONFIG_SUBHEADER',
              ...getProductsLocaleObject(config.value?.products_list),
            },
            merchants: {
              subheader: 'FORM_BRANDS_SUBHEADER',
              add_merchant: 'FORM_BRANDS_ADD_BRAND',
              some_filters_are_invalid: 'FORM_BRANDS_SOME_FILTERS_INVALID',
            },
            country_fees: {
              subheader: 'FORM_COUNTRY_FEES_SUBHEADER',
              all_countries: 'FORM_COUNTRY_FEES_ALL_COUNTRIES',
              add_country_fees: 'FORM_COUNTRY_FEES_ADD_COUNTRY_FEES',
              country_filter_is_invalid: 'FORM_COUNTRY_FEES_IS_INVALID',
            },
            save: 'FORM_SAVE',
          },
          confirm_remove: {
            title: 'DIALOG_REMOVE_TITLE',
            question: 'DIALOG_REMOVE_CONTENT',
            yes: 'DIALOG_REMOVE_YES',
            no: 'DIALOG_REMOVE_NO',
          },
          country_fees_settings_dialog: {
            header: 'SETTINGS_HEADER',
            form: {
              countries: 'SETTINGS_FORM_COUNTRIES',
              all_countries_readonly_info: 'SETTINGS_FORM_READONLY_INFO',
              player_registration_country_info: 'SETTINGS_FORM_PLAYER_COUNTRY_INFO',
              name_of_group: 'SETTINGS_FORM_NAME',
              deposit: 'SETTINGS_FORM_DEPOSIT',
              withdrawals: 'SETTINGS_FORM_WITHDRAWALS',
              save: 'SETTINGS_FORM_SAVE',
              cancel: 'SETTINGS_FORM_CANCEL',
              validations: {
                country_is_required: 'VALIDATIONS_COUNTRY_IS_REQUIRED',
                percent_cannot_be_less_than_0: 'VALIDATIONS_LESS_THAN_0',
                percent_cannot_be_greater_than_100: 'VALIDATIONS_GREATER_THAN_100',
              },
            },
          },
        },
      },
    },
  }));
}
